import { ContactsManageFields } from '../components/contacts-manage-fields/contacts-manage-fields';

export const CustomFieldsPage = () => {
  return (
    <div className="flex h-full min-h-0 w-full max-w-[1400px] flex-col">
      <ContactsManageFields variant="page" />
    </div>
  );
};
